(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("@angular/core"), require("lodash"), require("@angular/common"), require("@angular/forms"));
	else if(typeof define === 'function' && define.amd)
		define(["@angular/core", "lodash", "@angular/common", "@angular/forms"], factory);
	else if(typeof exports === 'object')
		exports["ng2-dropdown-treeview"] = factory(require("@angular/core"), require("lodash"), require("@angular/common"), require("@angular/forms"));
	else
		root["ng2-dropdown-treeview"] = factory(root["ng"]["core"], root["_"], root["ng"]["common"], root["ng"]["forms"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_0__, __WEBPACK_EXTERNAL_MODULE_1__, __WEBPACK_EXTERNAL_MODULE_12__, __WEBPACK_EXTERNAL_MODULE_13__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition